import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";

export default class ModalNotificationsSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className="notifs-sidebar"
        style={{ height: "80vh", overflowY: "auto" }}
      >
        <div className="content">
          {!_.isEmpty(this.props.listNotifications)
            ? this.props.listNotifications.map((element, index) => (
                <div className="unit-notif new" key={index}>
                  {element.message.fr}
                  <br />{" "}
                  <small>
                    {moment(element.dateTime).format("DD/MM/YYYY HH[h]mm")}{" "}
                  </small>
                </div>
              ))
            : ""}
        </div>
      </div>
    );
  }
}
